// extracted by css-extract-rspack-plugin
export default {"disabledNoteTooltip":"Ks4r3DL24Urv3vyn__disabledNoteTooltip___","paywallIcon":"iNov0Jy9YwcmLhl5__paywallIcon___"};